import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { AiTextGenerationRequest } from '../interfaces/ai-text-generation-request';
import { CommonService } from '@product/shared/services/common.service';
import { CustomAttribute } from '@product/shared/models/AttributeDTO';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class AIService {
  constructor(private http: HttpClient, private commonService: CommonService) {}
  
  generateText(request: AiTextGenerationRequest) {
    return this.http.post(
      `${AppConfigService.settings.apiUrl}ArtificialIntelligence/generate-text`,
      request,
    );
  }
  
  getText(
    request: AiTextGenerationRequest,
    question: string,
    attributesFormGroup: FormGroup,
    attributeCode: string
  ) {
    return new Promise<void>((resolve, reject) => {
      const pattern = /\{#attribute:(.*?)\}/g;
      const matches = question.match(pattern) as string[];
      const attributes = this.commonService.helperObject[
        'attributes'
      ] as CustomAttribute[];

      if (matches != null) {
        matches.forEach((x) => {
          const code = x.split(':')[1].replace('}', '').trim();
        
          const attribute = attributes.find((x) => x.name === code);
          const value = attributesFormGroup.get(
            attribute!.id!.toString()
          )?.value;
          if (value == null) {
            // this.message.error(`${code} attribute doesn't have value`);
            return;
          }
          if (attribute?.type === 6) {
            const options =
              this.commonService.dropDownMetaData[attribute!.id!.toString()];
            request.includedAttributes[code] = options.find(
              (x) => x.Code === value
            )!.Label;
          } else {
            request.includedAttributes[code] = value;
          }
        });
      }

      if (request.objectId != null) {
        
        this.generateText(request).subscribe((response: any) => {
          const result = response.text as string;
          if (attributesFormGroup && attributesFormGroup.get(attributeCode)){
          attributesFormGroup.get(attributeCode)?.setValue(result.trim());
          resolve();
          }
        });
      }
    });
  }
}
